import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './tufts-card-personnel.css.lit';
import tuftsHeadingCssLit from '../tufts-heading/tufts-heading.css.lit';
import { tuftsCard } from '../tufts-card/tufts-card';
import { classMap } from 'lit/directives/class-map.js';
import StyleTuftsButton from '../tufts-button/tufts-button.css.lit';

/**
 * The tuftsCardPersonnel component
 * @element tufts-card-personnel
 *
 * @slot photo
 * @slot name
 * @slot credentials
 * @slot email
 * @slot phone
 * @slot view-profile
 */
@customElement('tufts-card-personnel')
export class tuftsCardPersonnel extends tuftsCard {
  @property({
    type: String,
    reflect: true,
    attribute: 'version',
  })
  version: string;

  static styles: CSSResultGroup = [
    StyleTuftsButton,
    componentStyles,
    tuftsHeadingCssLit,
  ];

  render(): TemplateResult {
    const wrapperClasses = {
      'main-wrapper': true,
      'small': this.resizeController.currentBreakpointRange === 0,
      'medium': this.resizeController.currentBreakpointRange === 1,
      [this.version]: this.version,
    };
    return html`
      <article class=${classMap(wrapperClasses)}>
        ${this.ngSlot.conditionalNGSlot('photo')}
        <div class="content-wrapper">
          ${this.ngSlot.conditionalNGSlot('name', true, 'md')}
          <div class="content">
            ${this.ngSlot.conditionalNGSlot('credentials')}
            ${this.ngSlot.conditionalNGSlot('email')}
            ${this.ngSlot.conditionalNGSlot('phone')}
          </div>
          ${this.ngSlot.conditionalNGSlot('view-profile')}
        </div>
      </article>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-card-personnel': tuftsCardPersonnel;
  }
}
